import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { 
  User, 
  ChevronDown, 
  LogOut, 
  Heart, 
  ShoppingBag, 
  Package, 
  Shield, 
  BarChart3, 
  Settings, 
  Image,
  Search,
  Wallet
} from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTranslation } from "react-i18next";

interface UserDropdownMenuProps {
  user: any;
  showArtistContent: boolean;
  showBuyerContent: boolean;
  isAdmin: boolean;
  handleSignOut: () => void;
}

export const UserDropdownMenu = ({
  showArtistContent,
  showBuyerContent,
  isAdmin,
  handleSignOut,
}: UserDropdownMenuProps) => {
  const { t } = useTranslation('common');
  
  return (
    <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="gap-1">
            <User className="h-5 w-5" />
            <ChevronDown className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
        {showArtistContent && (
          <>
            <DropdownMenuItem asChild>
              <Link to="/upload" className="w-full cursor-pointer">
                <Button variant="default" className="w-full justify-start" size="sm">
                  <Package className="mr-2 h-4 w-4" />
                  {t('nav.sellNow')}
                </Button>
              </Link>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}
        <DropdownMenuItem asChild>
          <Link to="/profile" className="cursor-pointer">
            <User className="mr-2 h-4 w-4" />
            {t('nav.profile')}
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/settings" className="cursor-pointer">
            <Settings className="mr-2 h-4 w-4" />
            {t('nav.settings')}
          </Link>
        </DropdownMenuItem>
        {showArtistContent && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild>
              <Link to="/artist-dashboard" className="cursor-pointer">
                <BarChart3 className="mr-2 h-4 w-4" />
                {t('nav.artistDashboard')}
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/my-artworks" className="cursor-pointer">
                <Image className="mr-2 h-4 w-4" />
                {t('nav.myArtworks')}
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/artist-orders" className="cursor-pointer">
                <Package className="mr-2 h-4 w-4" />
                {t('nav.sales')}
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/payouts" className="cursor-pointer">
                <Wallet className="mr-2 h-4 w-4" />
                {t('nav.payouts')}
              </Link>
            </DropdownMenuItem>
          </>
        )}
        
        {showBuyerContent && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild>
              <Link to="/explore" className="cursor-pointer">
                <Search className="mr-2 h-4 w-4" />
                {t('nav.explore')}
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/favorites" className="cursor-pointer">
                <Heart className="mr-2 h-4 w-4" />
                {t('nav.favorites')}
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/orders" className="cursor-pointer">
                <ShoppingBag className="mr-2 h-4 w-4" />
                {t('nav.orders')}
              </Link>
            </DropdownMenuItem>
          </>
        )}
        {isAdmin && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild>
              <Link to="/admin" className="cursor-pointer">
                <Shield className="mr-2 h-4 w-4" />
                {t('nav.admin')}
              </Link>
            </DropdownMenuItem>
          </>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleSignOut} className="cursor-pointer">
          <LogOut className="mr-2 h-4 w-4" />
          {t('nav.signOut')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
